import { merge } from 'lodash';
export const nativeStyle = {
    nativeStyle: {
        text: {
            fontFamily: 'Madefor',
            color: '#20303C',
        },
        primaryText: {
            fontWeight: 700,
        },
        bgColor: {
            backgroundColor: '#F8F9FA',
        },
        secondary: {
            backgroundColor: '#E8ECF0',
        },
        whitebox: {
            borderRadius: '8px',
        },
        coverImage: {
            height: '70px',
            width: '70px',
            margin: '8px',
            border: '1px solid rgba(110, 120, 129, 0.1)',
        },
    },
};
export const withNativeStyle = theme => merge({}, nativeStyle, theme || {});
//# sourceMappingURL=useNativeStyle.js.map